module.exports = __webpack_public_path__ + "static/media/Glitch-7.ee693980.webp";